import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import type { UseQueryExecute } from "urql"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Instruction } from "@/graphql/codegen/graphql"
import useColumns from "@/screens/Products/components/Product/Instructions/components/tables/useColumns"

interface InstructionsAssociatedProps {
  data: Instruction[]
  productId: number
  refetchInstructionsList: UseQueryExecute
}

export const InstructionsAssociatedTable: FC<InstructionsAssociatedProps> = ({
  data = [],
  productId,
  refetchInstructionsList,
}) => {
  const columns = useColumns({ productId, refetchInstructionsList })
  return (
    <Box className='flex size-full flex-col'>
      <AerosBaseTable
        slotProps={{ bodyCellExpanded: { className: "bg-primary-100" } }}
        features={{
          tanstackOptions: {
            data,
            columns,
            state: {},
          },
        }}
      />
    </Box>
  )
}

export default InstructionsAssociatedTable
